<template>
  <div>
    <v-simple-table class="task-table" fixed-header height="730">
      <template v-slot:default>
        <thead>
          <tr>
            <th style="min-width: 60px; max-width: 60px"></th>
            <th style="min-width: 130px; max-width: 130px">Loại công việc</th>
            <th style="min-width: 200px; max-width: 200px">Học viên</th>
            <th style="min-width: 180px; max-width: 180px">Chương trình <span>/ Khoá học</span></th>
            <th style="min-width: 200px; max-width: 200px">Nội dung</th>
            <th style="min-width: 150px; max-width: 150px">
              <div class="d-flex align-center">
                Lịch hẹn
                <v-tooltip
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <img
                      @click="handleSortTimeAppointment"
                      v-on="on"
                      v-bind="attrs"
                      src="../trigger_task/assets/img/sort-icon.svg"
                      alt=""
                      class="ml-2"
                      style="cursor: pointer"
                    >
                  </template>
                  <span>{{apointmentSortStatus}}</span>
                </v-tooltip>
              </div>
            </th>
            <th style="min-width: 150px; max-width: 150px">Trạng thái</th>
            <th style="min-width: 250px; max-width: 250px">Người thực hiện</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="tasks.length > 0">
            <tr v-for="(item, index) in tasks" :key="index + item">
              <td>
                <v-icon
                  :color="item.status === 2 ? '#94C216' : '#A6A6A6'"
                  :style="item.status !== 2 ? 'cursor: pointer': ''"
                  @click="handleUpdateTask(item)"
                >
                  mdi-check-circle-outline
                </v-icon>
              </td>
              <td>
                <div
                  v-if="LIST_TYPE.find((e) => e.id === item.type)"
                  class="task-type"
                  :class="`${item.type === TASK_TYPE.EXTEND ? 'extend' : 'periodically-care'}`">
                  {{LIST_TYPE.find((e) => e.id === item.type).text}}
                </div>
              </td>
              <td>
                <div v-if="item.userStudent" style="font-weight: bold; max-width: 85%" class="d-flex justify-space-between align-center">
                  <div  @click="redirectSpecialCare(item)" style="cursor: pointer; width: 160px">{{item.userStudent.fullName}}</div>
                  <!-- <v-icon
                    style="font-size: 25px"
                    color="#4caf50"
                    @click="clickExecuteCall(item, item.mobile)"
                  >
                    mdi-phone
                  </v-icon> -->
                  <v-menu offset-y v-if="item.phoneRelated && item.phoneRelated.length">
                    <template v-slot:activator="{ on: menu, attrs }">
                        <div
                          class="d-flex flex-column align-center"
                          v-bind="attrs"
                          v-on="menu"
                        >
                          <v-icon
                            style="font-size: 25px"
                            color="#4caf50"
                          >
                            mdi-phone
                          </v-icon>
                        </div>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="clickExecuteCall(item, item.mobile)"
                        class="main-mobile"
                      >
                        <v-list-item-title>{{formatNormalStylePhone(item.mobile)}}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-for="(phone, index) in item.phoneRelated"
                        :key="index"
                        @click="clickExecuteCall(item, phone)"
                        class="sub-mobile"
                      >
                        <v-list-item-title>{{formatNormalStylePhone(phone)}}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <div
                    v-else
                    style="cursor: pointer"
                    @click.stop="clickExecuteCall(item, item.mobile)"
                  >
                    <v-icon
                      style="font-size: 25px"
                      color="#4caf50"
                    >
                      mdi-phone
                    </v-icon>
                  </div>
                </div>
              </td>
              <td>
                <span v-if="item.curriculum && item.curriculum.title">{{item.curriculum.title}}</span>
                <span >{{item.course.name}}</span>
              </td>
              <td>
                <v-tooltip
                  top
                  v-if="item.content"
                >
                  <template v-slot:activator="{on, attrs}">
                    <span
                      v-on="on"
                      v-bind="attrs"
                      @click="handleViewTaskDetail(item)"
                      style="cursor: pointer"
                    >
                      {{handleCutContent(item.content)}}
                    </span>
                  </template>
                  <span>Mở xem chi tiết công việc</span>
                </v-tooltip>
              </td>
              <td>
                <div :style="checkDateIsExpire(item) ? 'color : red' : ''">
                  {{formatDateCus(item.appointment_schedule, 'DD/MM/YYYY HH:mm')}}
                </div>
              </td>
              <td>
                <div
                  class="status-box"
                  v-if="item.status && TASK_STATUS[item.status]"
                  :class="`${TASK_STATUS[item.status].class}`"
                >
                  {{TASK_STATUS[item.status].text}}
                </div>
              </td>
              <td>
                <div v-if="item.user" >
                  {{item.user.name}}
                </div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td :colspan="7" class="text-center" style="height: 60px; color: red">
                Không có dữ liệu
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import {
  LIST_TYPE, TASK_TYPE, TASK_STATUS, TASK_STATUS_OPTION,
} from '@/modules/blended/const';
import TokenService from '@/helpers/token';
import { mapActions } from 'vuex';
import { TYPE_CURRICULUM_OBJ } from '@/helpers/constant';
import StudentCareServices from '@/services/StudentCareServices';

export default {
  name: 'ListCreatedTask',
  props: {
    typeScreen: {
      type: String,
      default: '',
    },
    tasks: {
      type: Array,
      default: () => [],
    },
    filterForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      LIST_TYPE,
      TASK_TYPE,
      TASK_STATUS,
      sortAppointmentSchedule: 'asc',
      clickedStudentId: null,
      clickedStudentTypeBlended: null,
      studentDetail: null,
    };
  },
  computed: {
    apointmentSortStatus() {
      if (this.sortAppointmentSchedule === 'desc') {
        return 'Sắp xếp từ cũ đến mới';
      }
      if (this.sortAppointmentSchedule === 'asc') {
        return 'Sắp xếp từ mới đến cũ';
      }
      return '';
    },
  },
  methods: {
    ...mapActions('blended', ['getListTask']),
    async handleUpdateTask(item) {
      if (item.status !== 2) {
        const result = await StudentCareServices.updateTask(item.id, { status: 2 });
        if (result.message === 'Success') {
          this.$swal({
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: 'Cập nhật trạng thái thành công!',
            position: 'top',
          });
          Bus.$emit('reloadListTask');
          this.$emit('recountTotalSuccess');
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Có lỗi xảy ra, vui lòng thử lại !',
          });
        }
      }
    },
    checkDateIsExpire(item) {
      return item.status === TASK_STATUS_OPTION.find((e) => e.text === 'Quá hạn').id;
    },
    async getStudentIdCare(lmsCoreUserId, curriculumId) {
      const params = {
        obj: 'routine',
        'filters[$eq__lms_core_user_id]': lmsCoreUserId,
        'filters[$eq__curriculum_id]': curriculumId,
        attrs: [
          'id',
          'lms_core_user_id',
          'curriculum_id',
          'homeroom_teacher_id',
          'homeroom_teacher_name',
          'type_blended',
          'contact_id',
          'customer_id',
          'full_name',
          'mobile',
          'call_id',
          'call_status_id',
          'subject_id',
          'created_at',
          'updated_at',
          'class_start_time',
          'number_lesson_passed',
          'routine_history_json',
          'number_lessons',
          'extend_sale_name',
          'end_date',
          'products',
          'previous_end_date',
          'extend_sale_at',
          'class_code',
          'type_customer_care',
          'type_curriculum',
          'status_id',
          'contact_code',
          'special_care_timein',
          'is_special_care',
          'is_new_call',
          'tutor_school_level',
          'student_product_id',
        ],
        'filters[$eq__is_main_curriculum]': 1,
        'filters[$eq__is_quick_view]': 1,
      };
      const result = await StudentCareServices.fgGetListCare(params);
      if (result.message === 'Success') {
        this.clickedStudentId = result.data[0].id;
        this.clickedStudentTypeBlended = result.data[0].type_blended;
        // eslint-disable-next-line prefer-destructuring
        this.studentDetail = result.data[0];
      }
    },
    handleCutContent(content) {
      let result = '';
      if (content.length > 30) {
        result = `${content.substr(0, 30)}...`;
      } else result = content;
      return result;
    },
    async redirectSpecialCare(item) {
      await this.getStudentIdCare(item.lms_core_user_id, item.curriculum_id);
      if (this.clickedStudentTypeBlended === 2) {
        const routeData = this.$router.resolve({ name: 'StudentDetailBlended', params: { id: this.clickedStudentId }, query: { typeCurriculum: TYPE_CURRICULUM_OBJ.ONLINE, schoolLevel: this.studentDetail.tutor_school_level } });
        window.open(routeData.href, '_blank');
      } else {
        const routeData = this.$router.resolve({
          name: 'StudentDetailTutor',
          params: { id: this.clickedStudentId },
          query: { typeCurriculum: this.$route.query.typeCurriculum, tutorSchoolLevel: this.studentDetail.tutor_school_level, taskType: 1 },
        });
        const permission = this.studentDetail.tutor_school_level === 'secondary' ? this.checkAuthorization('tutor-student-detail-secondary_read') : this.checkAuthorization('tutor-student-detail_read');
        if (permission) {
          window.open(routeData.href, '_blank');
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: 'Bạn không có quyền xem thông tin học viên',
          });
        }
      }
    },
    handleViewTaskDetail(item) {
      Bus.$emit('openModalTriggerTask', item);
    },
    async handleSortTimeAppointment() {
      if (this.sortAppointmentSchedule === 'desc') {
        this.sortAppointmentSchedule = 'asc';
      } else if (this.sortAppointmentSchedule === 'asc') {
        this.sortAppointmentSchedule = 'desc';
      }
      this.filterForm.sortAppointmentSchedule = this.sortAppointmentSchedule;
      const loading = this.$loading.show();
      // eslint-disable-next-line no-nested-ternary
      const tutorSchoolLevel = this.$route.name === 'TutorTask' ? this.$route.query.tutorSchoolLevel : this.$route.name === 'BlendedTask' ? this.$route.query.schoolLevel : '';
      await this.getListTask({
        ...this.filterForm,
        tutorSchoolLevel,
      });
      loading.hide();
    },
    async clickExecuteCall(dataContact, phone) {
      await this.getStudentIdCare(dataContact.lms_core_user_id, dataContact.curriculum_id);
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: dataContact.mainId,
          mainMobile: dataContact.mobile,
          store: 'T',
          contactCode: dataContact.contact_code,
          homeroomTeacherId: this.studentDetail.homeroom_teacher_id,
          studentProductId: this.studentDetail.student_product_id,
          callStatusId: this.studentDetail.call_status_id,
          callId: this.studentDetail.call_id,
        };
        Bus.$emit('voice-call-show-popup', data);
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
  },
};
</script>
<style lang="scss">
.task-table {
  thead {
    tr {
      th {
        background: #EFEFEF !important;
        color: #767575 !important;
        font-size: 13px !important;
      }
    }
  }
}
.task-type {
  font-weight: bold;
  &.extend {
    color: #8A2E7F;
  }
  &.periodically-care {
    color: #E5652A;
  }
}
.status-box {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-weight: bold;
  width: fit-content;
  font-size: 12px;
  padding: 2px 12px;
  &.expire {
    color: #610404;
    background: #FFD3D2;
  }
  &.pending {
    color: #401341;
    background: #F9D7FA;
  }
  &.done {
    color: #1F3835;
    background: #DDFFFB;
  }
}
</style>
